import "../PagesCss/Default.css";
import React, { Profiler, useState, useEffect } from "react";
import { useNavigate } from "react-router";
import ImageContainer from "./ImageContainer";
const Thankyou = (props) => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <>
      <>
        <div id="layoutSidenav">
          <div id="layoutSidenav_content">
            <main>
              <div className="container-xl px-4 mt-4">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="card mb-4" style={{ minHeight: "80vh" }}>
                      <ImageContainer selectedLanguage="en" />
                      <div
                        className="card-body"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <h1
                          className="notice-title"
                          style={{ fontSize: "44px", fontStyle: "italic" }}
                        >
                          {" "}
                          ThankYou!
                        </h1>

                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                          }}
                        >
                          <button
                            onClick={() => {
                              navigate("/dignityInput");
                            }}
                            className="btn btn-primary"
                          >
                            Proceed to Input page
                          </button>
                          <button
                            onClick={() => {
                              localStorage.setItem("Updateanotherlogin", "b");
                              navigate("/login");
                            }}
                            className="btn btn-primary"
                          >
                            Update another login
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
            <footer className="footer-admin mt-auto footer-light footerMobile">
              <div className="container-xl px-4">
                <div className="row">
                  <div className="col-md-6 small">
                    Progressive Estate Solutions Inc. {currentYear}
                  </div>
                  <a
                    className="col-md-6 text-md-end small"
                    href="/PrivacyStatement"
                  >
                    Privacy Statement
                  </a>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </>
    </>
  );
};
export default Thankyou;
